"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAttributeValuesCell = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const table_cell_styles_1 = require("../partials/table-cell.styles");
exports.StyledAttributeValuesCell = (0, styled_components_1.default)(table_cell_styles_1.StyledCommonTextTableCell) `
  .attribute-values-container {
    display: grid;
    grid-template-columns: min-content max-content;
    column-gap: ${({ theme }) => theme.spacing(1)};
    align-items: center;
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: 0.875rem;
    white-space: nowrap;

    & > div {
      display: flex;
      width: 14px;
    }

    &.value--crossed-out {
      text-decoration: line-through;
    }

    svg {
      font-size: inherit;
    }
  }
`;
